import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterParentMenuId"
    ,pure: false
})
export class FilterParentMenuId implements PipeTransform {
    transform(items : any[],filter:string) {
        // console.log("FilterParentMenuId",items,filter);
        if(!items || !filter){
            return items;
        }
  
        return items.filter((val,idx) => {
            // console.log("FilterParentMenuId",val.pMenuId,filter);
            if(val.pMenuId.indexOf(filter) > -1){
                return true;
            }else{
                return false;
            }
        });
    }
}